<div class="work-ui-gallery">
  @if (uploadEnabled()) {
    <div [class.show]="showUploadOnDesktop() || !documentsByDate().length"
         class="work-ui-gallery__upload">
      <work-ui-dropzone-multi (filesReceived)="uploadFiles($event)"
                              [(loadingState)]="fileUploadLoadingState"
                              [acceptImage]="true"
                              [acceptVideo]="true"
                              [hasLoadingState]="true" />
    </div>
  }
  <div class="width-100">
    <div class="margin-bottom-12 flex flex-row end vertical-center">
      <div class="work-buttons">
        @if (documentsByDate().length > 0 && selectModeEnabled()) {
          <work-ui-button (buttonClick)="selectAllToggle()"
                          [iconName]="allDocumentsSelected ? 'close' : 'check'"
                          [text]="allDocumentsSelected ? 'ALLE_ABWAEHLEN' :'ALLE_AUSWAEHLEN'"
                          size="small"
                          variant="secondary" />
        }
        @if (uploadEnabled()) {
          <work-ui-button (buttonClick)="showUploadOnDesktop.set(!showUploadOnDesktop())"
                          [iconName]="showUploadOnDesktop() || !documentsByDate().length ? 'close' : 'upload'"
                          [variant]="showUploadOnDesktop() || !documentsByDate().length ? 'primary' : 'secondary'"
                          class="work-ui-gallery__upload-button"
                          size="small"
                          text="HOCHLADEN" />
        }
      </div>
    </div>

    @if (documentsByDate().length > 0) {
      <div class="work-ui-gallery__grid">
        @for (day of documentsByDate(); track $index; let first = $first) {
          <div [class.margin-top-48]="!first"
               class="work-ui-gallery__title margin-bottom-8 fade-in">
            <div class="flex flex-row vertical-center space-between wrap">
              @if (selectModeEnabled()) {
                <work-ui-checkbox (checkedChange)="toggleDaySelection(day.documents, $event);"
                                  [checked]="day.selected"
                                  [labelBold]="true"
                                  [label]="day.date | formatDate: 'dddd, DD.MM.YYYY'"
                                  [noMargin]="true" />
              } @else {
                <h3>{{ day.date | formatDate: 'dddd, DD.MM.YYYY' }}</h3>
              }
            </div>
          </div>
          @for (document of day.documents; track $index) {
            <div (click)="determineImageAction(document)"
                 [class.batch-select]="batchSelectionDocuments.includes(document)"
                 [class.selected]="selectedDocuments().includes(document)"
                 [class.selection-active]="selectionModeActive"
                 class="work-ui-gallery__item fade-in selected">
              @if (selectModeEnabled()) {
                <work-ui-checkbox (click)="onCheckBoxClick($event, document)"
                                  [checked]="selectedDocuments().includes(document)"
                                  [noMargin]="true" />
              }
              @if (document.mimetype?.startsWith('video/')) {
                <div [style.background-image]="'url(' + (document.fileSrcThumbnail | prependServerToFileSrc) + ')'"
                     class="work-ui-gallery__video-placeholder">
                  <work-ui-icon [fontSize]="56" fontColor="white" name="play_circle" />
                </div>
              } @else {
                <img (mouseenter)="selectionModeActive ? setBatchSelection(document) : null"
                     [alt]="document.name"
                     [src]="document.fileSrcThumbnail | prependServerToFileSrc">
              }
              @if (document.projectId) {
                @let text = projectNameMap()[document.projectId];
                @if (text) {
                  <work-ui-badge [text]="text"
                                 size="small" />
                }
              }
            </div>
          }
        }
      </div>
      <work-ui-lightbox #lightbox
                        (documentAnnotated)="documentAnnotated.emit($event)"
                        (documentDeleted)="onLightboxDocumentDeleted($event)"
                        [annotationEnabled]="annotationEnabled()"
                        [connectedProjectNameMap]="projectNameMap()"
                        [images]="galleryDocuments()" />
    } @else {
      <div class="work-card work-card--empty-state">
        <div class="flex flex-column gap-16 center">
          <work-ui-icon [fontSize]="98"
                        name="no_photography" />
          <p>{{ 'KEINE_BILDER_VORHANDEN' | translate }}</p>
        </div>
      </div>
    }
  </div>
</div>

<work-ui-sticky-footer
  [animationState]="selectedDocuments().length > 0 ? 'show' : 'hide'"
  [hideOnInit]="true"
  padding="compact">
  <div class="flex flex-row space-between vertical-center gap-16 wrap">
    <div class="flex flex-row vertical-center gap-4">
      <work-ui-button (buttonClick)="endSelectionMode()"
                      [iconOnly]="true"
                      iconName="close"
                      variant="tertiary" />
      <p>{{ this.selectedDocuments().length }} {{ 'AUSGEWAEHLT' | translate }}</p>
    </div>
    <div class="work-buttons flex wrap">
      @if (canDelete()) {
        <work-ui-button (actionConfirmResult)="batchDeleteSelectedDocuments()"
                        iconName="delete"
                        size="small"
                        text="LOESCHEN"
                        variant="secondary"
                        workUiShowConfirmActionModal />
      }
      <work-ui-button [htmlLink]="batchDownloadDocumentUrl"
                      iconName="download"
                      size="small"
                      text="HERUNTERLADEN"
                      variant="secondary" />
      <work-ui-button iconName="picture_as_pdf"
                      size="small"
                      text="AUSWAHL_PDF_ERSTELLEN"
                      variant="secondary" />
      @if (projectId()) {
        <work-ui-button (buttonClick)="pauseSelectionMode(); moveSelectedDocuments.emit()"
                        iconName="prompt_suggestion"
                        size="small"
                        text="VERSCHIEBEN"
                        variant="secondary" />
      }
    </div>
  </div>
</work-ui-sticky-footer>

